import React from 'react'
import styled from 'styled-components'
import DownloadApp from '~/components/DownloadApp'
import DesktopContainer from '~/components/DesktopContainer'
import halfPhoneHalfWinit from "../../../public/static/images/webp/halfPhoneHalfWinit.webp"

const GradientBackground = styled.div`
  display: flex;
  flex-grow: 1;
  background-image: linear-gradient(
    180deg,
    ${props => props.theme.colors.background.main} 13%,
    ${props => props.theme.colors.background.page} 100%
  );
`

const DownloadAppOuterContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.colors.background.page};
  border: solid 1px ${props => props.theme.colors.ui.inputBorder};
  border-radius: 4px;
  display: flex;
  align-items: center;

`

const DownloadAppImageBackground = styled.div`
  width: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  background-image: url(${halfPhoneHalfWinit});
  ${props => props.theme.media.smallDesktop`background-image: none`};
`

const DownloadAppInnerContainer = styled.div`
  padding: 50px;
  width: 100%;
`

const NoTicketsDownloadApp = () => {
  return (
    <DesktopContainer>
      <DownloadAppOuterContainer>
        <DownloadAppImageBackground>
          <DownloadAppInnerContainer>
            <DownloadApp />
          </DownloadAppInnerContainer>
        </DownloadAppImageBackground>
      </DownloadAppOuterContainer>
    </DesktopContainer>
  )
}

export default NoTicketsDownloadApp
